<template>
	<div class="pg-button-wrapper-center">
		<div class="pg-button-wrapper row justify-content-center">
			<pgButton
				class="col-xs-12 col-sm-6 col-lg-3"
				:id="`icon-holder-${pg.MethodName}`"
				v-for="pg in paymentMethodsList"
				v-if="pg.MethodName !== 'epin' && pg.MethodName !== 'nexoncards'"
				:maintenance="pg.Status !== 'active'"
				:disabled="pg.Status !== 'active' || emailVerified || maxBalanceReached"
				:btnId="pg.MethodName"
				:key="pg.id"
				:label="$t(`wallet.${pg.MethodName}`)"
				:loading="loading"
				:pgDetails="pg"
				@click-pg="handleSelectPG">
			</pgButton>
			<div class="clearfix"></div>
		</div>

		<p v-if="checkMinorPgs" class="additional-methods text-center">
			{{ $t('wallet.additional-methods') }}
			<a
				@click="handleSelectPG(pg)"
				v-for="pg in paymentMethodsList"
				v-if="pg.MethodName === 'epin' || pg.MethodName ==='nexoncards'"
				:pgDetails="pg"
				:class="{ 'disabled': pg.Status !== 'active' || emailVerified || maxBalanceReached }"
				>
				{{ $t(`wallet.${pg.MethodName}`) }}<span>,</span>
				<p v-if="pg.Status !== 'active'" class="tooltiptext">{{ $t('wallet.pg-maintenance') }}</p>
			</a>
		</p>
	</div>
</template>

<script>
import pgButton from './pg-button';

export default {
	name: 'pgButtonGroup',
	components: {
		pgButton,
	},
	props: {
		paymentMethodsList: {
			required: true,
			type: Array,
			default: () => []
		},
		emailVerified: {
			type: Boolean,
			default: true
		},
		maxBalanceReached: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		checkMinorPgs() {
			return this.paymentMethodsList.find(list => list.MethodName === 'epin') || this.paymentMethodsList.find(list => list.MethodName === 'nexoncards');
		}
	},
	methods: {
		handleSelectPG(pgData) {
			if (pgData.Status === 'active') {
				this.$emit('click-pg', pgData);
			}
		},
	},
};
</script>

<style lang="less" scoped>
	.tooltiptext {
		opacity: 0;
  		width: 200px;
  		background-color: black;
  		color: #fff;
  		text-align: center;
  		border-radius: 6px;
  		padding: 10px 5px;
  		position: absolute;
  		z-index: 1;
  		top: 150%;
  		left: 50%;
		margin-left: -100px;
    	transition: opacity 0.15s linear;
	}

	.tooltiptext::after {
  		content: "";
  		position: absolute;
  		bottom: 100%;
  		left: 50%;
		margin-left: -5px;
		border-width: 5px;
		border-style: solid;
		border-color: transparent transparent black transparent;
	}

	.pg-btn-holder {
		display: inline-block;
		float: none;
	}

	.additional-methods {
		padding-top: 12px;
		a {
			position: relative;
  			display: inline-block;
			border-bottom: 1px dotted black;
			  
			cursor: pointer;
			text-decoration: underline;
			&.disabled {
				color: rgba(204, 204, 204, .5);
				cursor: not-allowed;
			}
			&:hover {
				.tooltiptext {
					opacity: 1;
				}
			} 
		}
		p {
			color: white;		
		}
		span {
			color: #8c8c8c;
		}
		a:last-child {
			span { display: none; }
		}
	}
	.pg-button-wrapper-center {
		margin: 0 auto;
		@media (min-width: 480px) {
			max-width: 100%;
		}
		@media (min-width: 600px) {
			max-width: 473px;
			text-align: left;
		}
		@media (min-width: 1024px) and (min-width: 1044px) {
			max-width: 964px;
			text-align: center;
		}
	}

	.pg-button-wrapper {
		margin: -5px 0;
		@media (min-width: 600px) {
			margin: -8px;
		}
		@media (min-width: 1024px) {
			margin-top: 0;
			margin-bottom: 0;
		}
	}

	@media (max-width: 600px) {
		.pg-btn-holder {
			width: 100%;
		}
	}
	.tw {
		.pg-button-wrapper-center {
			@media (min-width: 600px) {
				text-align: center;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/common/pg-button-group.vue